module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "t clearfix"
  }, [_c('div', {
    staticClass: "border",
    style: ({
      'min-height': _vm.winHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "center-date"
  }, [_c('h1', [_vm._v(_vm._s(_vm.yiji.Day))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.yiji.year) + "/" + _vm._s(_vm.yiji.month))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.yiji.week))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.yiji.n_year) + "年 " + _vm._s(_vm.yiji.n_month) + " " + _vm._s(_vm.yiji.n_day))])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-content"
  }, [_c('div', {
    staticClass: "content-list border-one"
  }, [_c('h3', {
    staticClass: "list-title clearfix"
  }, [_c('span', {
    staticClass: "list-icon-yi"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.yiTitle))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.yiDesc))])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-content"
  }, [_c('div', {
    staticClass: "content-list"
  }, [_c('h3', {
    staticClass: "list-title-two clearfix"
  }, [_c('span', {
    staticClass: "list-icon-two"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.jiTitle))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.jiDesc))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "logo",
    on: {
      "click": function($event) {
        _vm.logoB = !_vm.logoB
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.logoB) ? _c('div', {
    staticClass: "logoBg",
    on: {
      "click": function($event) {
        _vm.logoB = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoTxt"
  }, [_c('div', {
    staticClass: "logo-title clearfix"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/title-logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("简介")])]), _vm._v(" "), _c('p', [_vm._v(" 致力于倡导新中式健康生活，与你一同，感受身心节律，体验四时之美，换一种更自然的活法儿。"), _c('br'), _c('br'), _vm._v("\n          2007年成立至今，已有超过3000万用户使用了活法儿提供的“中医体质测试”、 “节气体质调理”等免费服务。旗下共有”过日子“等6款APP，全面覆盖饮食调养、月经调理、调体备孕、小病小痛等生活健康领域。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85ad0e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 20
// module chunks = 0